import { SvgType } from '@rocheglobal/component-library/src/services/svg';
import React, { useEffect, useState } from 'react';
import StoryblokClient from 'storyblok-js-client';
import { Props } from '../types';
import { Headline } from '../props/headline';
import { StoryblokService } from '../../services';

type PageProps = Props<{
  headline: Headline[];
  embed_code: string;
  description: string;
}>;

type Episode = {
  headline: { headline: string }[];
  image: { filename: string };
  description: string;
};

export const DynamicPodcastTeaser = ({ blok, slot }: PageProps): JSX.Element => {
  const teaserUrl = blok.link?.story?.url ? `/${blok.link?.story?.url}` : blok.link?.url;
  const fallbackImage = blok?.fallback_image?.filename;
  const fallbackHeadline = blok?.fallback_headline;
  const fallbackDescription = blok?.fallback_description;
  const link = {
    url: teaserUrl,
    text: blok.link_text,
    icon: 'chevron-right' as SvgType,
  };

  const [episode, setEpisode] = useState<Episode>(null);

  const fetchStory = async () => {
    const storyblokJsClient = new StoryblokClient({
      accessToken: StoryblokService.getConfig().options.accessToken as string,
    });
    const story = await storyblokJsClient.getStory(teaserUrl);
    const { body } = story?.data?.story?.content;
    if (!body) { return; }
    // find the first component roche-podigee-episode where use_as_latest_episode is set to true
    // eslint-disable-next-line prefer-regex-literals
    const regex = new RegExp('({[^{]*image.+?"use_as_latest_episode":true.*?})', 'm');
    const matches = JSON.stringify(body).match(regex);
    if (!matches || !matches[0]) { return; }
    const foundComponent: Episode = JSON.parse(matches[0]);
    setEpisode(foundComponent);
  };

  useEffect(() => {
    fetchStory();
  }, [blok]);

  return (
    <section slot={slot}>
      <roche-teaser
        style={{ marginTop: 0 }}
        headline={episode?.headline[0]?.headline || fallbackHeadline}
        teaser-url={link.url}
        description={episode?.description || fallbackDescription}
      >
        <roche-image src={episode?.image?.filename || fallbackImage} slot="media" />
        {link && <roche-generic-link slot="link" {...link} />}
      </roche-teaser>
    </section>
  );
};
